import axios from 'axios'

const externalApiBase = ''

const authClient = axios.create({
  baseURL: `${externalApiBase}/api/`
})

const response = (res) => res

const handleError = (error) => {
  return Promise.reject(error)
}

authClient.interceptors.response.use(response, handleError)

export default authClient
